import * as Connector from 'shared/connectors/offerConnector';
import { OFFER } from 'store/types';
import { USER_ROLES } from 'shared/consts';

const init = () => ({
  type: OFFER.GET_ACCEPTED_OFFERS_INIT,
});

export const success = data => ({
  type: OFFER.GET_ACCEPTED_OFFERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: OFFER.GET_ACCEPTED_OFFERS_FAILURE,
});

const getAcceptedOffers = ({ userRole, plotUuid, ddiUuid }) => async dispatch => {
  dispatch(init());
  try {
    let data;
    if (userRole === USER_ROLES.ADMIN && !ddiUuid) {
      data = await Connector.getAllAcceptedOffer(plotUuid);
    } else if (userRole === USER_ROLES.DDI || ddiUuid) {
      data = await Connector.getDdiAcceptedOffer(plotUuid, ddiUuid);
    }
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getAcceptedOffers;
